export default {
  color: {
    primary: "#5846f9",
    secondary: "#fcf2fc",
  },
};
